<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33325 10.8333H13.4999L8.83323 15.4999L9.99989 16.6666L16.6666 9.99991L9.99989 3.33325L8.83323 4.49991L13.4999 9.16657H3.33325V10.8333Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IcArrowRight',
} as DefineComponent
</script>
